import { isFulfilled } from "@reduxjs/toolkit";
import { Dispatch, FC, SetStateAction } from "react";
import { TBlockUnBlockCandidatePayload } from "../../../../models/vacancy";
import { useAppDispatch as useDispatch, useAppSelector as useSelector } from "../../../../store";
import { showNotificationAction } from "../../../../store/application/slice";
import { blockUnblockCandidateThunk } from "../../../../store/centers/thunks";
import { ICandidate } from "../../../../store/centers/types";
import { capitalizeName } from "../../../../utils/stringUtils";
import CustomButton from "../../../UI/Buttons/CustomButton";
import PopupModal from "../../../UI/Popup";

interface UnBlockCandidateProps {
  showUnblockModal: boolean;
  onClickClose: () => void;
  getCandidateDetails: ICandidate | null;
  setShowUnblockModal: Dispatch<SetStateAction<boolean>>
}

const UnblockCandidate: FC<UnBlockCandidateProps> = ({
  showUnblockModal,
  onClickClose,
  getCandidateDetails,
  setShowUnblockModal
}) => {
  const dispatch = useDispatch();

  const inProgress = useSelector((state) => state.Centres.inProgress);

  const handleUnblockCandidate = async() => {
    const payload: TBlockUnBlockCandidatePayload = {
      action: "unblock",
      user_id: getCandidateDetails?.id ?? 0
    }
    const res = await dispatch(blockUnblockCandidateThunk(payload))
    if(isFulfilled(res)){
      setShowUnblockModal(false)
      dispatch(showNotificationAction('Completed'))
    }
  }

  return (
    <>
      <PopupModal
        visible={showUnblockModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
        customWidth={650}
      >
        <div className="d-flex flex-column gap-20">
          <div className="d-flex flex-column gap-15">
            <div className="fs-22 fw-400 text-black">
              Unblock {capitalizeName(getCandidateDetails?.first_name ?? "") + " " + capitalizeName(getCandidateDetails?.last_name ?? "")}
            </div>
            <div className="fs-13 fw-400 text-black">
              You are about to unblock {capitalizeName(getCandidateDetails?.first_name ?? "") + " " + capitalizeName(getCandidateDetails?.last_name ?? "")}. Unblocking them
              will mean your centres will be visible to them and they may apply
              or accept your vacancies.
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <CustomButton
              variant={"primary"}
              type="button"
              className="btn-theme bg-teal text-black"
              contentClass="d-flex"
              isLoading={inProgress}
              onClick={handleUnblockCandidate}
            >
              Confirm and Unblock
            </CustomButton>
          </div>
        </div>
      </PopupModal>
    </>
  );
};

export default UnblockCandidate;